import * as CookieConsent from 'vanilla-cookieconsent';

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";


const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

export default class CookieModal {
    constructor() {

        this.init();
    }

    init() {
        window.addEventListener('load', () => {
            window.cc = CookieConsent;
            /**
             * All config. options available here:
             * https://cookieconsent.orestbida.com/reference/configuration-reference.html
             */
            CookieConsent.run({
                disablePageInteraction: true,
                revision: 1,

                onFirstConsent: () => {
                    this.updateGtagConsent();
                },
                onConsent: () => {
                    this.updateGtagConsent();
                },
                onChange: () => {
                    this.updateGtagConsent();
                },

                // Configure categories and services
                categories: {
                    [CAT_NECESSARY]: {
                        enabled: true,  // this category is enabled by default
                        readOnly: true,  // this category cannot be disabled
                    },
                    [CAT_ANALYTICS]: {
                        autoClear: {
                            cookies: [
                                {
                                    name: /^_ga/,   // regex: match all cookies starting with '_ga'
                                },
                                {
                                    name: '_gid',   // string: exact cookie name
                                }
                            ]
                        },
                        // See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
                        services: {
                            [SERVICE_ANALYTICS_STORAGE]: {
                                label: 'Enables storage (such as cookies) related to analytics e.g. visit duration.',
                            }
                        }
                    },
                    [CAT_ADVERTISEMENT]: {
                        services: {
                            [SERVICE_AD_STORAGE]: {
                                label: 'Enables storage (such as cookies) related to advertising.',
                            },
                            [SERVICE_AD_USER_DATA]: {
                                label: 'Sets consent for sending user data related to advertising to Google.',
                            },
                            [SERVICE_AD_PERSONALIZATION]: {
                                label: 'Sets consent for personalized advertising.',
                            },
                        }
                    },
                    [CAT_FUNCTIONALITY]: {
                        services: {
                            [SERVICE_FUNCTIONALITY_STORAGE]: {
                                label: 'Enables storage that supports the functionality of the website or app e.g. language settings.',
                            },
                            [SERVICE_PERSONALIZATION_STORAGE]: {
                                label: 'Enables storage related to personalization e.g. video recommendations.',
                            },
                        }
                    },
                    [CAT_SECURITY]: {
                        services: {
                            [SERVICE_SECURITY_STORAGE]: {
                                label: 'Enables storage related to security such as authentication functionality, fraud prevention, and other user protection.',
                            },
                        }
                    }
                },

                guiOptions: {
                    consentModal: {
                        layout: 'box wide',
                        position: 'right bottom',
                        equalWeightButtons: false                        
                    },
                    preferencesModal: {
                        layout: 'box',
                        equalWeightButtons: false
                    }
                },                

                language: {
                    default: 'en',
                    translations: {
                        en: {
                            consentModal: {
                                title: 'Our Use of Cookies',
                                description: 'To enhance your experience, this website utilises cookies. These help us tailor content and advertisements, integrate social media features, and understand how our site is used.',
                                acceptAllBtn: 'Accept all',
                                acceptNecessaryBtn: 'Reject all',
                                showPreferencesBtn: 'Manage Individual preferences',
                            },
                            preferencesModal: {
                                title: 'Manage cookie preferences',
                                acceptAllBtn: 'Accept all',
                                acceptNecessaryBtn: 'Reject all',
                                savePreferencesBtn: 'Accept current selection',
                                closeIconLabel: 'Close modal',
                                sections: [
                                    {
                                        title: "Cookie usage",
                                        description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience."
                                    },
                                    {
                                        title: "Strictly necessary cookies",
                                        description: "These cookies are essential for the proper functioning of the website, for example for user authentication.",
                                        linkedCategory: [CAT_NECESSARY],
                                        cookieTable: {
                                            headers: {
                                                name: "Name",
                                                domain: "Domain",
                                                description: "Description",
                                                expiration: "Expiration"
                                            },
                                            body: [
                                                {
                                                    name: "cookieconsent_status",
                                                    domain: "kingswoodhomes.uk.com",
                                                    description: "Stores the user's cookie consent state for the current domain",
                                                    expiration: "Expires after 1 year"
                                                },
                                                                                                {
                                                    name: "__cfduid",
                                                    description: "Used by Cloudflare to identify trusted web traffic.",
                                                    Service: "Cloudflare",
                                                    domain: ".calendly.com",
                                                    expiration: "1 month"
                                                }, 
                                                {
                                                    name: "__cf_bm",
                                                    description: "Used by Cloudflare to manage bot traffic.",
                                                    Service: "Cloudflare",
                                                    domain: ".calendly.com",
                                                    expiration: "30 minutes"
                                                },
                                                {
                                                    name: "_calendly_session",
                                                    description: "Preserves session state across page requests.",
                                                    Service: "Calendly",
                                                    domain: ".calendly.com",
                                                    expiration: "Session"
                                                },
                                                {
                                                    name: "_cfuid",
                                                    description: "Used by Cloudflare to identify trusted web traffic.",
                                                    Service: "Cloudflare",
                                                    domain: ".calendly.com",
                                                    expiration: "1 month"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        title: "Analytics",
                                        description: 'Cookies used for analytics help collect data that allows services to understand how users interact with a particular service. These insights allow services both to improve content and to build better features that improve the user’s experience.',
                                        linkedCategory: [CAT_ANALYTICS],
                                        cookieTable: {
                                            headers: {
                                                name: "Name",
                                                domain: "Service",
                                                description: "Description",
                                                expiration: "Expiration"
                                            },
                                            body: [
                                                {
                                                    name: "_ga",
                                                    domain: "Google Analytics",
                                                    description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                                    expiration: "Expires after 12 days"
                                                },
                                                {
                                                    name: "_gid",
                                                    domain: "Google Analytics",
                                                    description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                                    expiration: "Session"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        title: 'Advertising',
                                        description: 'Google uses cookies for advertising, including serving and rendering ads, personalizing ads (depending on your ad settings at <a href=\"https://g.co/adsettings\">g.co/adsettings</a>), limiting the number of times an ad is shown to a user, muting ads you have chosen to stop seeing, and measuring the effectiveness of ads.',
                                        linkedCategory: [CAT_ADVERTISEMENT],
                                        cookieTable: {
                                            headers: {
                                                name: "Cookie",
                                                Service: "Service",
                                                description: "Description"
                                            },
                                            body: [
                                                {
                                                    name: "_gcl_au",
                                                    description: "Used by Google AdSense to experiment with advertisement efficiency across websites using their services.",
                                                    Service: "Google AdSense",
                                                    expiration: "3 months"
                                                },
                                                {
                                                    name: "_gcl_aw",
                                                    description: "Used by Google AdWords to track and optimize ad performance.",
                                                    Service: "Google AdWords",
                                                    expiration: "3 months"
                                                },
                                                {
                                                    name: "_gcl_gs",
                                                    description: "Used by Google Ad Manager to deliver advertisements.",
                                                    Service: "Google Ad Manager",
                                                    expiration: "3 months"
                                                },
                                                {
                                                    name: "_fbp",
                                                    description: "Used by Facebook to deliver a series of advertisement products such as real time bidding from third party advertisers.",
                                                    Service: "Facebook",
                                                    expiration: "3 months"
                                                },
                                                {
                                                    name: "AEC",
                                                    description: "Used by Google AdSense to collect information about user behavior and improve ad targeting.",
                                                    Service: "Google AdSense",
                                                    expiration: "6 months"
                                                },
                                                {
                                                    name: "SOCS",
                                                    description: "Used by Google to deliver personalized advertisements on Google sites, based on recent searches and previous interactions.",
                                                    Service: "Google",
                                                    domain: ".google.com",
                                                    expiration: "13 months"
                                                },
                                                {
                                                    name: "DV",
                                                    description: "Used by Google Ads to provide ad delivery or retargeting services.",
                                                    Service: "Google Ads",
                                                    domain: "www.google.com",
                                                    expiration: "Session"
                                                },
                                            ]
                                        }
                                    },
                                    {
                                        title: 'Functionality',
                                        description: 'Cookies used for functionality allow users to interact with a service or site to access features that are fundamental to that service. Things considered fundamental to the service include preferences like the user’s choice of language, product optimizations that help maintain and improve a service, and maintaining information relating to a user’s session, such as the content of a shopping cart.',
                                        linkedCategory: [CAT_FUNCTIONALITY],
                                         cookieTable: {
                                            headers: {
                                                name: "Cookie",
                                                Service: "Service",
                                                description: "Description"
                                            },
                                            body: [
                                                {
                                                    name: "_hjSession_#",
                                                    description: "Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.",
                                                    Service: "Hotjar",
                                                },
                                                {
                                                    name: "_hjSessionUser_#",
                                                    description: "Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.",
                                                    Service: "Hotjar",
                                                }
                                            ]
                                        },
                                    },
                                    {
                                        title: 'Security',
                                        description: 'Cookies used for security authenticate users, prevent fraud, and protect users as they interact with a service.',
                                        linkedCategory: [CAT_SECURITY],
                                    },
                                    {
                                        title: 'More information',
                                        description: 'For any queries in relation to the policy on cookies and your choices, please <a href="https://kingswoodhomes.uk.com/privacy-policy/">contact us</a>.'
                                    }
                                ]
                            }
                        }
                    }
                }
            });
        });

    }
    updateGtagConsent() {
        gtag('consent', 'update', {
            [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
            [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
            [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
            [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
            [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_NECESSARY) ? 'granted' : 'denied',
            [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
            [SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedService(SERVICE_SECURITY_STORAGE, CAT_NECESSARY) ? 'granted' : 'denied',
        });
    }

}

